export default class Config {
  static getAPIURL(): string {
    if (process.env.NODE_ENV === "development") {
      return "http://localhost:8080/api";
    }
    return `/api`;
    // return `${this.publicUrl}`;
  }
}
